import ReactDOM from 'react-dom';
import App from './main';

ReactDOM.render(
  <>
    <App />
  </>,
  document.getElementById('root')
);
